import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import glamorous from 'glamorous';
import { RvLoader } from '../../components/Loader';
import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { ChartCommonProps, IconButtonWrapper, HelpWrapper, ChartCommonState, FooterDescription } from '../Common';
import { formatNumber, GetArrow, getMaxTickLimit, getLabels, getSuggestedMaxTick } from '../../helpers/ChartHelper';
import { WithStyles, withStyles, IconButton } from '@material-ui/core';
import { styles } from '../styles';
import { ChartFilter } from '../ChartComponents';
import { DrillDownType } from '../DrillDownType';
import { Line, getElementAtEvent } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Scale,
    Tick,
    Chart,
    ChartEvent,
    ActiveElement,
    // BarController, 
} from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import VideoLibraryOutlinedIcon from '@material-ui/icons/VideoLibraryOutlined';
import MTooltip from '@material-ui/core/Tooltip';
import { VideoModal } from '../../components/VideoModal';
import { ChartInfo } from '../../components/ChartInfo';

import { RV_CHART_CLASS, RV_CHART_COLORS, rvChartAnimation, rvValueAxisStyle, rvCategoryAxisStyle, rvTooltipStyle, isChartDataEmpty } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { ChartEmptyState } from '../ChartEmptyState';
import ShowChartOutlinedIcon from '@material-ui/icons/ShowChartOutlined';
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    // BarController,
    Title,
    Tooltip,
    Legend,
    zoomPlugin
);

const BarWrapper = glamorous.div<{ theme?: object }>((props) => ({
    position: 'relative',
    paddingBottom: '10px',
    flex: 1,
    display: 'flex',
    flexFlow: 'column',
    maxWidth: '100%',
    maxHeight: '100%',
    height: '100%',
    '@media print': {
        display: 'flex',
        flexFlow: 'column',
        alignItems: 'center',
    }
}));
const BarTitleContainer = glamorous.div<{ theme?: object }>((props) => ({
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    padding: '15px 15px 0px 15px',
    fontSize: '16px',
    fontWeight: 600,
    [`& .${`h1`}`]: {
        display: 'flex',
        alignItems: 'center',
    },
    [`& .${`h2`}`]: {
        fontSize: '2.5rem',
        padding: '10px 0',
    },
})).withProps({ className: 'rv-chart-title-area' });
const BarContainer = glamorous.div<{ theme?: object }>((props) => ({
    padding: '5px 15px 15px 15px',
    minHeight: '300px',
    flex: 1,
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxHeight: '350px',
    maxWidth: 'auto',
    position: 'relative',
    '@media (max-width: 533px)': {
        maxWidth: '350px',
        margin: '0 auto',
    },
    [`& .${`titleWrapper`}`]: {
        textAlign: 'center',
        display: 'inline-block',
        width: '100%',
        padding: '15px',
        [`& .${`title`}`]: {
            fontSize: '18px',
            fontWeight: 600,
            display: 'block',
            marginBottom: '15px',
        },
        [`& .${`value`}`]: {
            fontSize: '24px',
            fontWeight: 600,
            display: 'block',
            marginBottom: '15px',
        },
        [`& .${`secondary-title`}`]: {
            fontSize: '16px',
            fontWeight: 400,
            display: 'block',
            marginBottom: '15px',
        }
    }
}));
const LoadWrapper = glamorous.div<{ theme?: object }>((props) => ({
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
}));
const TotalDiv = glamorous.div<{ theme?: object }>((props) => ({
    cursor: 'pointer',
    paddingRight: 5
}));

export interface QueryDefaultType {
    loading?: boolean;
    // tslint:disable-next-line: no-any
    result?: any;
    // tslint:disable-next-line: no-any
    error?: any;
}
interface ChartProps extends ChartCommonProps, WithStyles<typeof styles> {
    getSelectedItem?: (
        searchCriterias: Array<SearchCriteria>, 
        isShowCompleted: boolean, 
        title?: string,
        drillDownType?: DrillDownType,
        defaultView?: string,
        alternativeKey?: {
            [key: string]: any
        },
        sortColumn?: string,
        sortDirection?: string,
        isIncludeNameFinancial?: boolean,
        isLead?: boolean,
    ) => void;
    chartFilter?: ChartFilter;
    infoUrl: string | null;
}
interface ChartState extends ChartCommonState {
    isVideoModalOpen: boolean;
}
class LeadsOpenedInTheLastTwelveMonthsChart extends React.Component<ChartProps, ChartState>  {

    // tslint:disable-next-line: no-any
    public chartRef: React.RefObject<any>;

    constructor(props: ChartProps, state: ChartState) {
        super(props, state);
        this.onPan = this.onPan.bind(this);
        this.onCloseChart = this.onCloseChart.bind(this);
        this.handlePopoverOpen = this.handlePopoverOpen.bind(this);
        this.handlePopoverClose = this.handlePopoverClose.bind(this);
        this.handleTotalClick = this.handleTotalClick.bind(this);
        this.onHover = this.onHover.bind(this);
        this.onToggleVideo = this.onToggleVideo.bind(this);
        this.chartRef = React.createRef();
        this.state = {
            open: false,
            anchorEl: undefined,
            isVideoModalOpen: false
        };
    }
    public componentDidMount() {
        // 
    }
    public componentWillUnmount() {
        // 
    }
    public shouldComponentUpdate(nextProps: ChartProps, nextState: ChartState): boolean {
        if (this.props !== nextProps || this.state !== nextState) {
           return true;
        }
        return false;
    }
    public render() {
        // const { classes } = this.props;
        return (            
            <React.Fragment>
                {this.state.isVideoModalOpen && this.props.infoUrl && (
                    <VideoModal 
                        open={this.state.isVideoModalOpen}
                        onClose={this.onToggleVideo}
                        url={this.props.infoUrl}
                    />
                )}
                <Query<CurrencySymbolData> query={CurrencySymbolQuery}>
                    {
                    // tslint:disable-next-line: no-any
                    (result) => {
                        if (result.loading) {
                            return (
                                <ChartSkeleton variant="line" />
                            );
                        }
                        
                        const symbol = (result.loading || result.error ||
                            result.data === null || result.data === undefined)
                            ? ''
                            : result.data.options.currencySymbol.symbol;
                        
                        return(
                            <Query<ChartDataQueryData, ChartDataQueryDataVariables> 
                                query={ChartDataQuery}
                                variables={{
                                    entityType: this.props.chartFilter?.entityType,
                                    entityGuid: this.props.chartFilter?.entityGuid,
                                    responsibility: this.props.chartFilter?.responsibility
                                }}
                            > 
                                {({ loading, error, data }) => {
                                    if (loading) {
                                        return (
                                            <LoadWrapper className="load-wrapper">
                                                <RvLoader size="small" />
                                            </LoadWrapper>
                                        );
                                    }
                                    const statistics = data?.statistics;
                                    let matter = (loading || error ||
                                        statistics === null || statistics === undefined)
                                        ? null
                                        : statistics.matter;
                                    let leadsOpenedInLastTwelveMonths = matter ? matter.matterLeadsOpenedInLastTwelveMonths : null;
                                    if (leadsOpenedInLastTwelveMonths) {
                                        const lastTwelveMonths = leadsOpenedInLastTwelveMonths.matterLeadsOpenedCountTotal;
                                        const previousTwelveMonths = leadsOpenedInLastTwelveMonths.previousYearMatterLeadsOpenedCountTotal;
                                        // tslint:disable-next-line: no-any
                                        let months = leadsOpenedInLastTwelveMonths.matterLeadOpenedInLastTwelveMonths.map((value: any) => { 
                                            return value.month; });
                                        // tslint:disable-next-line: no-any
                                        let counts = leadsOpenedInLastTwelveMonths.matterLeadOpenedInLastTwelveMonths.map((value: any) => { 
                                            return value.count; 
                                        });
                                        // tslint:disable-next-line: no-any
                                        let estimatedFees = leadsOpenedInLastTwelveMonths.matterLeadOpenedInLastTwelveMonths.map((value: any) => {
                                            return value.estimate;
                                        });
                                        // tslint:disable-next-line: no-any
                                        let previousCounts = leadsOpenedInLastTwelveMonths.matterLeadOpenedInPreviousTwelveMonths.map((value: any) => {
                                            return value.count;
                                        });
                                        // tslint:disable-next-line: no-any
                                        // let previousEstimatedFees = leadsOpenedInLastTwelveMonths.matterOpenedInPreviousTwelveMonths.map((value: any) => {
                                        //     return value.estimate;
                                        // });
                                        // let suggestedMax = Math.round(highestCount + (highestCount * 0.10));
                                        return (
                                            <BarWrapper className={RV_CHART_CLASS}>
                                                <IconButtonWrapper aria-label="close">
                                                    <HelpWrapper className="rv-chart-help">
                                                        <ChartInfo description={this.props.description} />
                                                        {this.props.infoUrl && (
                                                            <MTooltip title="Learn more">
                                                                <IconButton
                                                                    style={{ color: 'rgb(0, 120, 212)' }}
                                                                    aria-label="maximize"
                                                                    onClick={this.onToggleVideo}
                                                                    size={this.props.showAllRecords ? 'medium' : 'small'}
                                                                >
                                                                    <VideoLibraryOutlinedIcon />
                                                                </IconButton>
                                                            </MTooltip>
                                                        )}
                                                    </HelpWrapper>
                                                    <IconButton aria-label="close" onClick={this.onCloseChart} size="small">
                                                        <CloseIcon />
                                                    </IconButton>
                                                </IconButtonWrapper>
                                                <BarTitleContainer>
                                                    <ChartHeading icon={<ShowChartOutlinedIcon />} title="New Leads in the last 12 months" />
                                                    <TotalDiv className="h2" onClick={() => this.handleTotalClick(true)}>
                                                        <AnimatedNumber value={lastTwelveMonths.count} format={(amount) => formatNumber(amount)} />
                                                        {GetArrow(lastTwelveMonths.count, previousTwelveMonths.count)}
                                                    </TotalDiv>
                                                    <div className="h3">
                                                        <TotalDiv onClick={() => this.handleTotalClick(false)}>{formatNumber(previousTwelveMonths.count)}</TotalDiv>
                                                        leads opened in the 12 months before that
                                                    </div>
                                                </BarTitleContainer>
                                                <BarContainer>
                                                    <Line
                                                        ref={this.chartRef}
                                                        // tslint:disable-next-line: no-any
                                                        onClick={(event: React.MouseEvent<any>) => {
                                                            const _data = getElementAtEvent(this.chartRef.current, event);
                                                            if (_data.length > 0 && this.props.getSelectedItem) {
                                                                const _index = getElementAtEvent(this.chartRef.current, event)[0].index;

                                                                const item = months[_index];

                                                                const searchCriterias = new Array<SearchCriteria>();
                                                                // Pass property and month range.
                                                                // Comparison value should be in month/ MMM as displayed in the graph
                                                                // . e.g. - Jan, Feb, etc
                                                                searchCriterias.push(
                                                                    { property: 'InstructionDateMonthStart', operator: 'gteq', comparison: item },
                                                                    { property: 'InstructionDateMonthEnd', operator: 'lteq', comparison: item },
                                                                );
                                                                this.props.getSelectedItem(
                                                                    searchCriterias,
                                                                    false,
                                                                    'New Leads in the last 12 months',
                                                                    DrillDownType.matterSummaryDrilldown,
                                                                    'matters',
                                                                    undefined,
                                                                    undefined,
                                                                    undefined,
                                                                    undefined,
                                                                    true
                                                                );
                                                            }
                                                        }}
                                                        data={{
                                                            labels: getLabels(months),
                                                            datasets: [
                                                                {
                                                                    fill: false,
                                                                    label: 'Leads',
                                                                    backgroundColor: RV_CHART_COLORS.primary,
                                                                    borderColor: RV_CHART_COLORS.primary,
                                                                    borderWidth: 3,
                                                                    tension: 0.35,
                                                                    pointRadius: 3,
                                                                    pointHoverRadius: 5,
                                                                    hoverBackgroundColor: RV_CHART_COLORS.primary,
                                                                    hoverBorderColor: RV_CHART_COLORS.primary,
                                                                    data: counts,
                                                                },
                                                                {
                                                                    fill: false,
                                                                    label: 'Previous Leads',
                                                                    backgroundColor: RV_CHART_COLORS.primarySoft,
                                                                    borderColor: RV_CHART_COLORS.primarySoft,
                                                                    borderWidth: 3,
                                                                    tension: 0.35,
                                                                    pointRadius: 3,
                                                                    pointHoverRadius: 5,
                                                                    hoverBackgroundColor: RV_CHART_COLORS.primarySoft,
                                                                    hoverBorderColor: RV_CHART_COLORS.primarySoft,
                                                                    data: previousCounts,
                                                                    pointStyle: 'dash',
                                                                    borderDash: [10, 5],
                                                                },
                                                            ],
                                                        }}
                                                        options={{
                                                            onHover: this.onHover,
                                                            indexAxis: 'x' as const,
                                                            animation: rvChartAnimation(),
                                                            elements: { bar: { borderWidth: 0 } },
                                                            responsive: true,
                                                            maintainAspectRatio: false,
                                                            scales: {
                                                                y: {
                                                                    grid: rvValueAxisStyle.grid,
                                                                    beginAtZero: true,
                                                                    suggestedMax: getSuggestedMaxTick([...counts, ...previousCounts]),
                                                                    min: 0,
                                                                    ticks: {
                                        ...rvValueAxisStyle.ticks,
                                                                        maxTicksLimit: getMaxTickLimit([...counts, ...previousCounts]),
                                                                        autoSkip: false,
                                                                        callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                                                            return `${formatNumber(tickValue)}`;
                                                                        },
                                                                    },
                                                                },
                                                                x: {
                                                                    grid: rvCategoryAxisStyle.grid,
                                                                    // min: 0,
                                                                    // max: 11 // minimum display
                                                                    ticks: {
                                        ...rvCategoryAxisStyle.ticks,
                                                                        autoSkip: false,
                                                                    },
                                                                },
                                                            },
                                                            plugins: {
                                                                legend: {
                                                                    position: 'bottom' as const,
                                                                    display: false,
                                                                },
                                                                title: {
                                                                    display: false,
                                                                    text: `Leads Opened in the last 12 months: ${formatNumber(lastTwelveMonths.count)}`,
                                                                },
                                                                zoom: {
                                                                    pan: {
                                                                        enabled: false,
                                                                        onPan: this.onPan,
                                                                    },
                                                                    zoom: {
                                                                        wheel: {
                                                                            enabled: false,
                                                                        },
                                                                    },
                                                                    // limits: {
                                                                    //   y: { min: 0, max: 9 },
                                                                    // },
                                                                },
                                                                tooltip: {
                                                                    ...rvTooltipStyle,
                                                                    callbacks: {
                                                                        // tslint:disable-next-line: no-any
                                                                        label: function (context: any) {
                                                                            const {
                                                                                // dataIndex,
                                                                                dataset,
                                                                                // label,
                                                                                formattedValue,
                                                                            } = context;
                                                                            // console.log(label, dataIndex);
                                                                            return `${dataset.label} ${formattedValue}`;
                                                                        },
                                                                        // tslint:disable-next-line: no-any
                                                                        afterLabel: function (context: any) {
                                                                            const { dataIndex, dataset } = context;
                                                                            if (dataset.label.toLowerCase() === 'leads') {
                                                                                const _estimatedFee = estimatedFees[dataIndex];
                                                                                return `Estimated Fees ${symbol}${formatNumber(_estimatedFee)}`;
                                                                            }
                                                                            return [];
                                                                        },
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {isChartDataEmpty(counts, previousCounts) && (
                                                        <ChartEmptyState title="No new leads" hint={"Nothing in the last 12 months."} />
                                                    )}
                                                </BarContainer>
                                                <FooterDescription>
                                                    {symbol}
                                                    {formatNumber(lastTwelveMonths.totalEstimates)} total estimated fees,
                                                    <br />
                                                    {formatNumber(lastTwelveMonths.mattersWithoutEstimate)} leads without estimates in the last 12 months
                                                    <br />
                                                    {symbol}
                                                    {formatNumber(previousTwelveMonths.totalEstimates)} total estimated fees, <br />
                                                    {formatNumber(previousTwelveMonths.mattersWithoutEstimate)} leads without estimates in the 12 months before that
                                                </FooterDescription>
                                            </BarWrapper>
                                        );
                                    }
                                    return (
                                        <LoadWrapper className="load-wrapper">
                                            <RvLoader size="small" />
                                        </LoadWrapper>
                                    );
                                }}
                            </Query>
                        );
                    }}
                </Query>
            </React.Fragment>
        );
    }
    private handleTotalClick(isCurrent: boolean) {
        if (this.props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();
            searchCriterias.push(
                { property: '12MonthPeriod', operator: 'eq', comparison: isCurrent ? 'curr' : 'prev' }
            );
            this.props.getSelectedItem(
                searchCriterias,
                false,
                'New Leads in the last 12 months',
                DrillDownType.matterSummaryDrilldown,
                'matters',
                undefined,
                undefined,
                undefined,
                undefined,
                true
            );
        }        
    }
    private onCloseChart() {
        if (this.props.onCloseChart) {
            return this.props.onCloseChart('isLeadsOpenedInTheLastTwelveMonthsChartOpen');
        }
    }
    // tslint:disable-next-line: no-any
    private handlePopoverOpen(event: any) {
        this.setAnchorEl(event.currentTarget);
    }
    private handlePopoverClose = () => {
        this.setAnchorEl(null);
    }
    // tslint:disable-next-line: no-any
    private setAnchorEl(anchorElValue: any) {
        this.setState({
            anchorEl: anchorElValue,
            open: Boolean(anchorElValue)
        });
    }
    private onPan = (context: { chart: Chart }) => {
        this.chartRef.current.options.scales.y.min = 0;
        this.chartRef.current.update();
    }
    
    private onHover(event: ChartEvent, elements: ActiveElement[], chart: Chart) {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    }

    private onToggleVideo() {
        this.setState({
            isVideoModalOpen: !this.state.isVideoModalOpen
        });
    }
}
const StyledChart = withStyles(styles, { withTheme: true })(LeadsOpenedInTheLastTwelveMonthsChart);

export default StyledChart as React.ComponentType<Omit<ChartProps, 'classes'>>;

interface CurrencySymbolData {
    options: Options;
}

interface Options {
    currencySymbol: CurrencySymbol;
}

interface CurrencySymbol {
    symbol: string;
}

const CurrencySymbolQuery = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;

interface ChartDataQueryDataVariables {
    entityType?: number;
    entityGuid?: string;
    responsibility?: number;
}

interface ChartDataQueryData {
    statistics: Statistics;
}

interface Statistics {
    matter: Matter;
}

interface Matter {
    matterLeadsOpenedInLastTwelveMonths: MatterLeadsOpenedInLastTwelveMonths;
}

interface MatterLeadsOpenedInLastTwelveMonths {
    matterLeadsOpenedCountTotal:             MatterLeadsOpenedCountTotal;
    previousYearMatterLeadsOpenedCountTotal: MatterLeadsOpenedCountTotal;
    matterLeadOpenedInLastTwelveMonths:      MatterLeadOpenedInTwelveMonth[];
    matterLeadOpenedInPreviousTwelveMonths:  MatterLeadOpenedInTwelveMonth[];
}

interface MatterLeadOpenedInTwelveMonth {
    month:    string;
    count:    number;
    estimate: number;
}

interface MatterLeadsOpenedCountTotal {
    count:                  number;
    mattersWithoutEstimate: number;
    totalEstimates:         number;
}

const ChartDataQuery = gql`
    query LeadsOpenedInLastTwelveMonthsChartDataQ($entityType: Int, $entityGuid: String, $responsibility: Int) {
        statistics{
            matter{
                matterLeadsOpenedInLastTwelveMonths(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility){
                    matterLeadsOpenedCountTotal{
                        count
                        mattersWithoutEstimate
                        totalEstimates
                    }
                    previousYearMatterLeadsOpenedCountTotal{
                        count
                        mattersWithoutEstimate
                        totalEstimates
                    }
                    matterLeadOpenedInLastTwelveMonths{
                        month,
                        count,
                        estimate
                    }
                    matterLeadOpenedInPreviousTwelveMonths{
                        month,
                        count,
                        estimate
                    }
                }
            }
        }
    }
`;